import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "progress"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { LinearProgress } from '@mui/material';
import { absurd } from 'fp-ts/function';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ProgressBar = /*#__PURE__*/forwardRef(function ProgressBar(_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      progress = _ref.progress,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(LinearProgress, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    variant: "determinate",
    value: progress,
    sx: mergeSxProps(props.sx, {
      backgroundColor: function backgroundColor(t) {
        return t.palette.secondary.main;
      },
      borderRadius: 2,
      height: function height(t) {
        return t.spacing(size === 'small' ? 0.5 : size === 'medium' ? 1 : size === 'large' ? 2 : absurd(size));
      }
    })
  }));
});